import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

export default function CategoryTable() {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState('');

  const fetchCategories = async () => {
    const res = await axios.get('/api/categories.php', { withCredentials: true });
    setCategories(res.data);
  };

  const addCategory = async () => {
    if (!newCategory.trim()) return;
    await axios.post('/api/categories.php', { category_name: newCategory });
    setNewCategory('');
    fetchCategories();
  };

  const updateCategory = async (id, name) => {
    await axios.put(`/api/categories.php?id=${id}`, { category_name: name });
    fetchCategories();
  };

  const deleteCategory = async (id) => {
    if (window.confirm('Delete this category?')) {
      await axios.delete(`/api/categories.php?id=${id}`);
      fetchCategories();
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <div className="p-4 max-w-2xl ml-4">
        <h2 className="text-xl font-semibold mb-4 text-gray-700">Categories</h2>
            <div className='rounded-sm overflow-x-auto shadow-xl'>
                <table className="w-full divide-y divide-gray-200 text-sm text-gray-500">
                    <thead>
                        <tr className="bg-gray-700 text-white text-left">
                            <th className=" p-2">Category Name</th>
                            <th className="text-center p-2">Actions</th>
                        </tr>
                    </thead>
                    <tbody className='divide-y divide-gray-200 bg-white shadow-2xl'>
                        {categories.map(cat => (
                            <tr key={cat.id}>
                                <td className=" p-2">
                                    <input
                                        className="w-full  rounded px-2 py-1"
                                        value={cat.category_name}
                                        onChange={(e) => updateCategory(cat.id, e.target.value)}
                                    />
                                </td>
                                <td className=" p-2 text-center">
                                    <button onClick={() => deleteCategory(cat.id)} className="text-red-500 hover:underline"><FontAwesomeIcon icon={faTrash} /></button>
                                </td>
                            </tr>
                        ))}
                        <tr className='text-center'>
                            <td className=" p-2">
                                <input
                                    className=" px-3 py-1 rounded w-full"
                                    value={newCategory}
                                    onChange={(e) => setNewCategory(e.target.value)}
                                    placeholder="New category name"
                                />
                            </td>
                            <td className=" p-2"><button onClick={addCategory} className="bg-gray-200  px-3 py-[1px] rounded text-gray-700 shadow-xl font-semibold">save</button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
  );
}
